const Status = (api: any) => ({
  getStatusFlowTransitions: (statusFlowId: number, statusId: number) =>
    api.get(`/api/v1/status/${statusId}/status-flow/${statusFlowId}/transition`, {}, {}),
  getStatusItem: (statusId: number) =>
    api.get(`/api/v1/status/${statusId}`, {}, {}),
});

export default Status;
